<template>
  <bk-page class="rightsDetailPage" pageType="navPage" :navBarInfo="navBarInfo" :loading="loadView==='view'">
    <bk-view class="view-rightsDetail-main" v-if="formData.id">
			<bk-tabs v-model:value="tabActive" :dataList="tabList"></bk-tabs>
			
			<bk-view class="view-content" v-if="tabActive=='1'">
				<bk-view class="view-shop-main">
					<bk-view class="view-header">
						<bk-view>{{ formData.saleCompName}}</bk-view>
						<bk-button v-if="systemInfo[formData.saleCompId] && systemInfo[formData.saleCompId]['MASE119']" size="middle" langCode="userInfo_memberRights_book" @click="handleBook"></bk-button>
					</bk-view>
					<bk-view class="view-address">
            <bk-icon icon="icon-dizhi"></bk-icon>
						<bk-view>{{formData.saleCompAddress || '-'}}</bk-view>
          </bk-view>
				</bk-view>

				<bk-view class="view-right-warp">

					<bk-view class="view-rightInfo-mian">
						<bk-view class="view-name-main">
							<bk-view class="view-name">{{formData.name}}</bk-view>
							<bk-view>{{formData.goodsCode}}</bk-view>
						</bk-view>
						<bk-view class="view-baseInfo-main">
							<bk-view class="view-baseInfo-item" v-for="item in baseInfoList" :key="item.key">
								<bk-lang class="view-label" :code="item.langCode"></bk-lang>
								<bk-view class="view-value">
									<bk-price v-if="item.type==='price'" 	:unitText="currencySymbol" :value="item.value"></bk-price>
									<bk-date v-else-if="item.type==='date'" :curShop="formData" :date="item.value" :showHm="item.showHm" />
									<bk-view v-else>{{ item.value != null ? item.value : '-'}}</bk-view>
									<bk-view v-if="item.slot==='discount'" class="view-dis">
										<bk-lang code="userInfo_memberRights_rightsDetail_dis"></bk-lang>
									</bk-view>
								</bk-view>
							</bk-view>
						</bk-view>
					</bk-view>	
					
					<bk-view class="view-applicable-main">
						<bk-lang class="view-label" code="userInfo_memberRights_rightsDetail_applicableTo"></bk-lang>
						<template v-if="rightType !=='packages'">
							<bk-view class="veiw-applicable-item" v-if="formData.applicableProjectText">
								<bk-lang class="view-label" code="userInfo_memberRights_rightsDetail_services"></bk-lang>
								<bk-view class="view-value">{{ formData.applicableProjectText || '-'}}</bk-view>
							</bk-view>
							<bk-view class="veiw-applicable-item" v-if="formData.applicableProductText">
								<bk-lang class="view-label" code="userInfo_memberRights_rightsDetail_products"></bk-lang>
								<bk-view class="view-value">{{ formData.applicableProductText || '-'}}</bk-view>
							</bk-view>
						</template>
						<bk-view class="veiw-applicable-item">
							<bk-lang class="view-label" code="userInfo_memberRights_rightsDetail_stores"></bk-lang>
							<bk-view class="view-value" v-if="formData.applyShopType===1">{{formData.applicableStoreText}}</bk-view>
							<bk-view class="view-value" v-else>
								<bk-view v-for="item in formData.applyShopList" :key="item.id">{{item.compName}}</bk-view>
							</bk-view>
						</bk-view>
					</bk-view>
				</bk-view>
				
				
				<bk-view class="view-package-main" v-if="rightType ==='packages'">
					<bk-title langCode="userInfo_memberRights_rightsDetail_applicableTo"></bk-title>
					<bk-view class="view-package-table">
						<packagesTable :dataList="formData.summaryGroupList" />
					</bk-view>
				</bk-view>

				<bk-view class="view-exclusivePrice-main" v-if="formData.initInfo && formData.initInfo?.projectExclusivePriceList?.length">
					<bk-view class="view-exclusivePrice-item" v-for="item in  formData.initInfo?.projectExclusivePriceList" :key="item.id">
						<bk-view class="view-info-main">
							<bk-view>{{item.goodsCode}}-{{item.goodsName}}</bk-view>
							<bk-view class="view-price-main">
								<bk-price class="view-goodsPrice"  :unitText="currencySymbol" :value="item.goodsPrice"></bk-price>
								<bk-price class="view-standPrice"  :unitText="currencySymbol" :value="item.standPrice"></bk-price>
							</bk-view>
						</bk-view>
						<bk-view class="view-categoryName">{{item.categoryName}}</bk-view>
					</bk-view>
				</bk-view>
			</bk-view>

			<bk-view class="view-history-content" v-if="tabActive=='2'">
				<bk-scroll-list 
					ref="listScroll" 
					:beforeSearch="beforeSearch"  
					:async-load-data="requestGetHistoryList" 
					emptyType="noData" 
					langCode_description="userInfo_memberRights_rightsDetail_description"
				>
					<template v-slot="{ dataList }">
						<bk-view class="view-history-main">
							<bk-view class="view-history-item" v-for="item in dataList" :key="item.id">
								<bk-view class="view-header-main">
									<bk-view>
										<bk-lang code="userInfo_memberRights_rightsDetail_ref" />{{item.billNo}}
									</bk-view>
									<bk-date :date="item.createDate" :curShop="item" showHm ></bk-date>
								</bk-view>
								<bk-view class="view-consume-main">
									<bk-view class="view-consume-source">
										<bk-icon icon="icon-mendian"></bk-icon>
										<bk-view class="view-name">{{ item.useCompName}}</bk-view>
									</bk-view>
									<bk-view class="view-consume-info">
										<bk-view class="view-consume-item" v-for="(billItem,billIndex) in item.billItems" :key="billIndex">
											<bk-view class="view-name">{{billItem.goodsName}}</bk-view>
											<bk-view class="view-price" v-if="[1,4].includes(formData.goodsType)">
												<span>-</span>
												<bk-price :value="billItem.payAmount" :unitText="currencySymbol"></bk-price>
											</bk-view>
											<bk-view class="view-price" v-if="[2,3,5].includes(formData.goodsType)">
												<span>-</span>
												{{billItem.usedTimes}}
												<bk-lang code="userInfo_memberRights_rightsDetail_session"></bk-lang>
											</bk-view>
										</bk-view>
									</bk-view>

									<bk-view class="view-balance" v-if="formData.goodsType===1">
										<bk-lang code="userInfo_memberRights_rightsDetail_remainder"></bk-lang>
										<bk-price :value="item.balance" :unitText="currencySymbol"></bk-price>
									</bk-view>
									<bk-view class="view-balance" v-if="[2,3].includes(formData.goodsType)">
										<bk-view :value="item.balance">{{item.remainTimes}}</bk-view>
										<bk-lang style="padding-left:2px;" code="userInfo_memberRights_rightsDetail_remaining"></bk-lang>
									</bk-view>
								</bk-view>
							</bk-view>
						</bk-view>
					</template>
				</bk-scroll-list>
			</bk-view>
    </bk-view>
	</bk-page>
</template>

<script>
	import packagesTable from './packagesTable/packagesTable.vue';
	import { customerReq, shopReq } from '@/reqService';
	
	export default {
		name: 'rightsDetail',
		components:{ packagesTable },
		props:{
			rightType:String,
			curRows:Object,
			currencySymbol:String,
			systemInfo:Object,
		},
		data (){
			return {
				formData:{},
				showPage:'',
				curItem:null,
				tabActive:'1',
				tabList:[
					{langCode:'userInfo_memberRights_rightsDetail_details', key:'1'},
					{langCode:'userInfo_memberRights_rightsDetail_usageHistory', key:'2'},
				],
				historyList:[],
				loadView:''
			};
		},
		computed:{
			navBarInfo (){
				return {
					langCode_title:`userInfo_memberRights_${this.rightType}`,
					backFlag: true,
				};
			},
			baseInfoList (){
				const res = this.formData;

				let items = [];

				const commonBeforeItem = [
					{langCode:'userInfo_memberRights_rightsDetail_purchaseStore', value: res.saleCompName},
					{langCode:'userInfo_memberRights_rightsDetail_purchaseDate', value: res.settleDate?.showValue, type:'date', showHm:true},
					this.isShowPrice() && {langCode:'userInfo_memberRights_rightsDetail_price', value: res.actualPrice, type:'price'},
				].filter(Boolean);

				// 会员权益
				if(this.rightType==='membership'){

					// 储值
					if(res.goodsType===1){
						items = [
							{langCode:'userInfo_memberRights_rightsDetail_initialStoredValue', value: res.value, type:'price'},
							{langCode:'userInfo_memberRights_rightsDetail_initialBonusValue', value: res.bonusValue, type:'price'},
							{langCode:'userInfo_memberRights_rightsDetail_storedValueBalance', value: res.balance, type:'price'},
							{langCode:'userInfo_memberRights_rightsDetail_bonusvalueBalance', value: res.bonusBalance, type:'price'},
							{langCode:'userInfo_memberRights_rightsDetail_discount', slot:'discount', value:`${res.projectDiscountText}/${res.productDiscountText}/${res.privilegeDiscountText}`},
							{langCode:'userInfo_memberRights_rightsDetail_validFor', value: res.validDateText },
						];
					}
					// 折扣
					if(res.goodsType===2){
						let sessions = res.usageLimit ? res.useTimes : this.$bk_lang['userInfo_memberRights_usageLimit'];
						items = [
							{langCode:'userInfo_memberRights_rightsDetail_sessions', value: sessions },
							res.usageLimit == 1 && {langCode:'userInfo_memberRights_rightsDetail_remaining', value: res.remainTimes },
							{langCode:'userInfo_memberRights_rightsDetail_discount', slot:'discount', value:`${res.projectDiscountText}/${res.productDiscountText}/${res.privilegeDiscountText}`},
							{langCode:'userInfo_memberRights_rightsDetail_validFor', value: res.validDateText },
						];
					}
					// 品项
					if(res.goodsType===3){

						items = [
							{langCode:'userInfo_memberRights_rightsDetail_sessions', value: (res.buyTimes || 0) + (res.giveTimes || 0) },
							res.usageLimit == 1 && {langCode:'userInfo_memberRights_rightsDetail_remaining', value: res.remainTimes },
							{langCode:'userInfo_memberRights_rightsDetail_validFor', value: res.validDateText },
						];
					}
				
				}

				// 礼品卡
				if(this.rightType==='giftCard'){
					// 储值
					if(res.goodsType===4){
						items = [
							{langCode:'userInfo_memberRights_rightsDetail_value', value: (res.value || 0)},
							{langCode:'userInfo_memberRights_rightsDetail_singleUsedQty', value: (res.singleUsageQty || 0)},
							{langCode:'userInfo_memberRights_rightsDetail_validFor', value: res.validDateText },
						];
					}
					// 次数
					if(res.goodsType===5){
						items = [
							{langCode:'userInfo_memberRights_rightsDetail_sessions', value: 1},
							{langCode:'userInfo_memberRights_rightsDetail_singleUsedQty', value: (res.singleUsageQty || 0)},
							{langCode:'userInfo_memberRights_rightsDetail_validFor', value: res.validDateText },
						];
					}

				
				}

				// 套餐 
				if(this.rightType==='packages'){
					items = [
						{langCode:'userInfo_memberRights_rightsDetail_validFor', value: res.validDateText },
					];
				}

				items = commonBeforeItem.concat(items);

				return items.filter(Boolean);
			},
			dataList (){
				const { applyProjectList=[], applyProductList=[]} = this.formData;

				if(this.tabActive=='2'){
					return this.historyList;
				}

				return [].concat(applyProjectList).concat(applyProductList);
			},
		},
		mounted (){
			this.initData();
		},
		methods:{
			initData (){
				this.requestGetMemberRightDetail();
			},
			isShowPrice (){
				let res = false;
				const { saleCompId, goodsType } = this.formData;
				let value = this.systemInfo[saleCompId]?.MASE291 || [];
				
				// 会员权益
				if(this.rightType==='membership'){
					// 储值
					if(goodsType===1){
						res = value.includes('0');
					}

					// 折扣
					if(goodsType===2){
						res = value.includes('1');
					}

					// 品项
					if(goodsType===3){
						res = value.includes('2');
					}
				}

				// 礼品卡
				if(this.rightType==='giftCard'){
					res = value.includes('3');
				}

				// 套餐 
				if(this.rightType==='packages'){
					res = value.includes('4');
				}

				return res;
			},
			getSearchParams (){
				const params = {
					rightType: this.rightType,
					id: this.curRows?.id,
				};
				return params;
			},
			requestGetMemberRightDetail (){
				this.loadView = 'view';
				customerReq.requestGetMemberRightDetail(this, this.getSearchParams()).then((res) => {
					this.formData = res;
					this.loadView = '';

					if(res.applyShopType===1){
						this.requestGetChainInfoByKeyword();
					}
				}).catch(() => {
					this.loadView = '';
				});
			},
			async requestGetChainInfoByKeyword (){
				if(this.formData.custId){
					const res = await shopReq.requestGetChainInfoByKeyword(this, { custId: this.formData.custId});
					this.formData.applyShopList = res.companyList;  
				}
			},
			setShowPage (showPage = '') {
				this.showPage = showPage;
			},
			handleItemClick (item){
				this.curItem = item;
				this.setShowPage('rightsDetail');
			},
			beforeSearch (params){
				params.id = this.curRows?.id;
				params.custId = this.curRows?.custId;
				params.rightType = this.rightType;
				params.changeTypeList = 3;
				return params;
			},
			async requestGetHistoryList (params){
				const res= await customerReq.requestGetMemberRightConsumeHistoryList(this, params);

				res.list = (res.list || []).map((item) => {
					item.createDate = item.createDate.displayValue;

					item.remainTimes = (item.billItems || []).reduce((num, nextItem) => {
						return num + (nextItem.remainTimes || 0);
					}, 0 );

					return item;
				});
				return {data: res.list, total: res.page?.total };
			},
			handleBook (){
				if (typeof window.showReserve == 'function') {

					window.showReserve({
						resShopInfo:{ id:this.formData.compId },
						resItemInfo: undefined,
					});
					
				}
			
			}
		}
		
	};
</script>

<style lang="less">
@import './rightsDetail.less';
</style>